package com.hyperether.goodjob.util

import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.models.User

object DataUtil {
    /**
     * Enrich a Job with user data from the users list.
     * Customize this function as needed to update job fields with user info.
     */
    fun enrichJobAssigneesWithUsers(job: Job, users: List<User>): Job {
        val assignees = job.assignees
        if (assignees?.employees != null) {
            val enrichedEmployees = assignees.employees?.map { employee ->
                employee?._id?.let { empId ->
                    users.find { it._id == empId } ?: employee
                } ?: employee
            }
            val newAssignees = assignees.copy(employees = enrichedEmployees)
            return job.copy(assignees = newAssignees)
        }
        return job
    }

    /**
     * Enrich a Job with user data from the users list.
     * Customize this function as needed to update job fields with user info.
     */
    fun enrichJobNotesWithUsers(job: Job, users: List<User>): Job {
        val notes = job.noteObjects
        if (notes?.isNotEmpty() == true) {
            val enrichedNotes = notes.map { note ->
                val user = note.userId?.let { noteUserId -> users.find { it._id == noteUserId } }
                if (user != null) {
                    note.copy(createdBy = user.getName())
                } else {
                    note
                }
            }
            return job.copy(noteObjects = enrichedNotes)
        }
        return job
    }

    /**
     * Enrich a list of Pair<String, FileEntity> with user names for fileObject.createdBy field.
     * For each file, if fileEntity.fileObject?.createdBy matches a user _id, set fileEntity.fileObject.createdBy to user.getName().
     * Returns a new list of Pair<String, FileEntity> with updated fileObject.createdBy fields.
     */
    fun enrichFilesWithUsers(
        files: List<Pair<String, FileEntity>>,
        users: List<User>
    ): List<Pair<String, FileEntity>> {
        return files.map { (key, fileEntity) ->
            val fileObj = fileEntity.fileObject
            if (fileObj != null) {
                val user = users.find { it._id == fileObj.userId }
                if (user != null) {
                    val updatedFileObject = fileObj.copy(createdBy = user.getName())
                    key to fileEntity.copy(fileObject = updatedFileObject)
                } else {
                    key to fileEntity
                }
            } else {
                key to fileEntity
            }
        }
    }
}